var App = App || {};

App.MediaCenter = (function ($) {
    'use strict';

    function init() {
        var mediaCenter = $(".widget-media-center");

        mediaCenter.each(function () {
            var Layout = $(this).find(".widget-media-center-layout");
            var ItemSelector = ".item-media-center";
            App.Masonry.Init(Layout, ItemSelector);


            $(this).find("#see-more-bios").click(function () {

                $(ItemSelector).each(function () {
                    if ($(this).hasClass("hidden")) {
                        $(this).toggleClass("hidden", "show");
                        $(this).show(200);
                    }
                });

                setTimeout(function () {
                    App.Masonry.MasonryDestroy(Layout, ItemSelector);
                    App.Masonry.Init(Layout, ItemSelector); 
                }, 500); 

                mediaCenter.find(".widget-media-center__see-more").hide(100);
            });
        });

    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.MediaCenter.init();
});